import {z} from '@hono/zod-openapi';

const hondaCurrentRecallSchema = z.object({
  campaignCode: z.string().openapi({example: '297'}),
  shortDescription: z.string(),
  longDescription: z.string(),
  reference: z.string().nullable().openapi({example: 'T9-06-002-1'}),
  vehicleKind: z.enum(['car', 'motorcycle', 'unknown']),
});

export const hondaRecallsByVinResponseSchema = z
  .object({
    vin: z.string().openapi({example: 'SHHEU87401U008156'}),
    recalls: z.array(hondaCurrentRecallSchema),
  })
  .openapi('HondaRecallsByVinResponse');

export type HondaRecallsByVinResponse = z.infer<typeof hondaRecallsByVinResponseSchema>;
